export var Sizes;
(function (Sizes) {
    Sizes["SM"] = "sm";
    Sizes["MD"] = "md";
    Sizes["LG"] = "lg";
})(Sizes || (Sizes = {}));
export var Variants;
(function (Variants) {
    Variants["DEFAULT"] = "default";
    Variants["XMARK_VARIANT"] = "xmarkVariant";
    Variants["BG_VARIANT"] = "backgroundVariant";
})(Variants || (Variants = {}));
export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["NOT_FOUND"] = "404";
    ErrorCodes["UNAUTHORIZED"] = "401";
    ErrorCodes["FORBIDDEN"] = "403";
    ErrorCodes["INTERNAL_SERVER_ERROR"] = "500";
    ErrorCodes["SERVICE_NOT_AVAILABLE"] = "503";
})(ErrorCodes || (ErrorCodes = {}));
//# sourceMappingURL=ErrorPage.types.js.map